import styled from "styled-components";

export const Wrapper = styled.div`
  border: 1px solid #e8f1ff;
  border-radius: 12px;
  align-self: stretch;
  padding: 1rem 2rem 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  [aria-selected="false"] {
    opacity: 50%;
  }
`;
